import {
  Box,
  FormControl,
  FormLabel,
  Input,
  useColorModeValue,
} from "@chakra-ui/react";
import { DateTime } from "luxon";
import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

interface CommonProps {
  title?: string;
  isRequiredFalse?: boolean;
  name: string;
  value: DateTime | null | string;
  onChange?: (date: DateTime | null, name: string) => void;
  disabled?: boolean;
  placeholderText?: string;
  maxDate?: Date | null;
  minDate?: Date | null;
}

const ReactDatePicker2: React.FC<CommonProps> = ({
  title,
  isRequiredFalse,
  disabled,
  onChange,
  name,
  value,
  placeholderText,
  maxDate,
  minDate
}) => {
  const textColor = useColorModeValue("navy.700", "white");
  const [selectedDate, setSelectedDate] = React.useState<Date | null>(null);

  React.useEffect(() => {
    if (typeof value === "string") {
      const newValue = DateTime?.fromISO(value);
      setSelectedDate(newValue?.toJSDate());
    } else if (value instanceof DateTime) {
      setSelectedDate(value?.toJSDate());
    } else {
      setSelectedDate(null);
    }
  }, [value]);

  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);

    if (onChange) {
      const newValue = date ? DateTime.fromJSDate(date) : null;
      onChange(newValue, name);
    }
  };

  return (
    <FormControl isRequired={isRequiredFalse ? false : true}>
      {title && (
        <FormLabel
          display="flex"
          ms="4px"
          fontSize="sm"
          fontWeight="500"
          color={textColor}
          mb="8px"
        >
          {title}
        </FormLabel>
      )}

      <Box>
        <DatePicker
          disabled={disabled}
          showPopperArrow={false}
          style={{ color: "#000" }}
          selected={selectedDate}
          onChange={handleDateChange}
          customInput={
            <Input variant="auth" fontSize="sm" fontWeight="500" size="lg" />
          }
          dateFormat="yyyy-MM-dd"
          placeholderText={placeholderText ?? "select date"}
          maxDate={maxDate}
          minDate={minDate}
        />
      </Box>
    </FormControl>
  );
};

export default ReactDatePicker2;

const dateBoxStyle = {
  border: "1px solid #E0E5F2",
  borderRadius: 16,
  padding: 2.5,
};
